module.exports = global["registration"] = require("-!C:\\Users\\david\\projects\\svenskdirektreklam\\sdr\\DelaReklam\\assets_src\\js\\angular.registration.js");


/*****************
 ** WEBPACK FOOTER
 ** ./assets_src/js/angular.registration.js
 ** module id = 7
 ** module chunks = 0
 **/